import SparkMD5 from 'spark-md5'

export const DEFAULT_WAVEFORMS_PATH = 'waveforms'

export const WAVEFORM_SAMPLE_LENGTH = 500

/**
 * Predicts the filename of the waveform data based on the audio URL.
 * Supports both Node.js and Browser environments.
 */
export interface HashWaveformFilenamePredictorOptions {
  baseURL?: string
  path?: string
}

export class HashWaveformFilenamePredictorService {
  baseURL: string
  path: string

  /**
   * @param baseURL The base URL of the drive where the files are stored
   */
  constructor(options: HashWaveformFilenamePredictorOptions = {}) {
    this.baseURL = options.baseURL ?? ''
    this.path = options.path ?? DEFAULT_WAVEFORMS_PATH
  }

  /**
   * @throws {Error} if the URL is not valid
   */
  private urlToPath(url: string) {
    const path = new URL(url).pathname
    return path
  }

  private hash(data: string) {
    return SparkMD5.hash(data)
  }

  public predictFilename(url: string) {
    const path = this.urlToPath(url)
    const hash = `${this.hash(path)}.json`
    return hash
  }

  public predictLocation(url: string) {
    const filename = this.predictFilename(url)
    return `${this.path}/${filename}`
  }

  public predictHash(url: string) {
    const path = this.urlToPath(url)
    return this.hash(path)
  }

  public predictURL(url: string) {
    const filename = this.predictFilename(url)
    return `${this.baseURL}/${this.path}/${filename}`
  }
}
